import { render } from "./BaseChart.vue?vue&type=template&id=5205f5ec&scoped=true"
import script from "./BaseChart.vue?vue&type=script&lang=js"
export * from "./BaseChart.vue?vue&type=script&lang=js"

import "./BaseChart.vue?vue&type=style&index=0&id=5205f5ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5205f5ec"]])

export default __exports__